import React, { useEffect, useState } from 'react';
import { TYPE_CONSTANT } from '../../constant/Web_constant';
import { get_dynamic_styles_with_default_value } from '../../constant/DynamicStylesWithDefaultValue';
import { useScreenSize } from '../../hooks/useScreenSize';
import {
  HomeBoxDefaultStyles,
  HomeDefaultColumnStyles,
  HomeMainDefaultStyles,
} from '../../constant/default_styles/HomeDefaultStyles';
import {
  responsive_column_styles,
  responsive_design_styles,
  responsive_row_styles,
} from '../../utils/ResponsiveDesign';
import { latest_editor_version } from '../../constant/Version';
import { get_dynamic_styles } from '../../constant/DynamicStyles';
import Link from 'next/link';
import Alert from '../Shared/PopUp/Alert';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import ALink from '../../constant/ALink';
import { dynamic_user_card_block_decide } from './DynamicUserCardBlockDecide';

const DynamicUserCardLayout = ({ user }) => {
  const dispatch = useDispatch();
  const router = useRouter();

  //
  const dynamic_card = TYPE_CONSTANT.STYLES_CONFIGS?.dynamic_user_card;
  const { width } = useScreenSize();

  return (
    <>
      <ALink href={`/u/${user.id}`}>
        <div
          className=" cursor-pointer"
          style={get_dynamic_styles_with_default_value(
            responsive_design_styles({
              width,
              parent_group: dynamic_card?.styles,
              child_group_name: 'main_styles',
            }),
            HomeMainDefaultStyles
          )}
        >
          <div
            className="flex flex-col  "
            style={get_dynamic_styles_with_default_value(
              responsive_design_styles({
                width,
                parent_group: dynamic_card?.styles,
                child_group_name: 'box_styles',
              }),
              HomeBoxDefaultStyles
            )}
          >
            {dynamic_card?.schema?.map((row) => {
              const {
                columns,
                current_editor_version = '',
                ...column_styles
              } = row || {};
              const row_styles = responsive_row_styles({
                parent_group: row,
                width,
              });
              return (
                <div
                  className={``}
                  style={
                    current_editor_version == latest_editor_version
                      ? {
                          display: row_styles?.display,
                          gridTemplateColumns:
                            row_styles?.columns_box_percentage,
                          ...get_dynamic_styles(row_styles),
                        }
                      : {
                          ...get_dynamic_styles(row_styles),
                          display:
                            row_styles?.isShowInMobile === false
                              ? 'none'
                              : 'grid',
                          gap: row_styles?.gap_between_columns ?? '24px',
                          gridTemplateColumns:
                            width > 768
                              ? row_styles?.columns_box_percentage
                                ? row_styles?.columns_box_percentage
                                : `repeat(${
                                    row.columns?.length ?? 1
                                  }, minmax(0, 1fr))`
                              : row?.['768_row_styles']
                              ? row_styles?.columns_box_percentage
                              : '100%',
                        }
                  }
                >
                  {/* Columns */}
                  {columns?.map((column, index) => {
                    const current_column_style = responsive_column_styles({
                      parent_group: column_styles,
                      index,
                      width,
                    });

                    return (
                      <div
                        className="flex   "
                        style={{
                          ...get_dynamic_styles_with_default_value(
                            current_column_style,
                            HomeDefaultColumnStyles
                          ),
                        }}
                      >
                        {column?.map((item) => {
                          return (
                            dynamic_user_card_block_decide({
                              ...item,
                              screen_width: width,
                              user,
                            }) && (
                              <>
                                {dynamic_user_card_block_decide({
                                  ...item,
                                  screen_width: width,
                                  user: { ...user },
                                })}
                              </>
                            )
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </ALink>
    </>
  );
};

export default DynamicUserCardLayout;
